export default (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 1.25C12 0.5625 11.46 0 10.8 0H1.2C0.54 0 0 0.5625 0 1.25V8.75C0 9.4375 0.54 10 1.2 10H10.8C11.46 10 12 9.4375 12 8.75V1.25ZM10.8 1.25L6 4.375L1.2 1.25H10.8ZM10.8 8.75H1.2V2.5L6 5.625L10.8 2.5V8.75Z"
            fill="white"
        />
    </svg>
)
